"use client";
import { useRef, useState, type ReactNode } from "react";
import { Check, Copy } from "lucide-react";

export default function CopyCode({ children }: { children: ReactNode }) {
  const code = useRef<HTMLPreElement>(null);
  const [state, setState] = useState<"idle" | "copied" | "failed">("idle");
  return (
    <div className="group relative my-4 min-w-0 rounded-lg border border-border bg-muted/30">
      <button
        type="button"
        aria-label="Copy code"
        className="absolute right-2 top-2 inline-flex items-center gap-1 rounded-md border border-border bg-background px-2 py-1 text-xs text-foreground focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary"
        onClick={async () => {
          try {
            await navigator.clipboard.writeText(code.current?.innerText ?? "");
            setState("copied");
          } catch {
            setState("failed");
          }
        }}
      >
        {state === "copied" ? <Check size={13} /> : <Copy size={13} />}
        <span aria-live="polite">
          {state === "copied"
            ? "Copied"
            : state === "failed"
            ? "Select to copy"
            : "Copy"}
        </span>
      </button>
      <pre
        ref={code}
        className="m-0 overflow-x-auto p-4 pt-12 text-[13px] leading-6"
      >
        {children}
      </pre>
    </div>
  );
}
